import $ from 'jquery';
import { uaCheck, showAccordion } from "./modules/utils";

// 重複チェック・歯抜けチェック
function formCheck() {
  const selectElms = document.querySelectorAll('.select-elm');
  const submitBtn = document.getElementById('submitBtn');
  if (selectElms.length === 0 || !submitBtn) return;

  const ERROR_MESSAGE_CLASS_NAME = 'show-message';
  const INITIAL_VALUE_KEY = 'initValue';

  // エラーメッセージを隠す
  const showError = (target) => {
    target.classList.add(ERROR_MESSAGE_CLASS_NAME);
  };

  // エラーメッセージを表示する
  const resetErrorMessage = () => {
    selectElms.forEach((elm) => {
      elm.classList.remove(ERROR_MESSAGE_CLASS_NAME);
    });
  };

  // ボタンを非活性にする
  const inactiveBtn = () => {
    submitBtn.disabled = true;
  };

  // ボタンを活性にする
  const activeBtn = () => {
    submitBtn.disabled = false;
    // console.log('ボタン活性');
  };

  /**
   * 必須項目が入力されていない場合 => true
   * @returns {boolean}
   */
  const doNotInputRequired = () => {
    let bool = false;
    const selectElms1 = document.querySelectorAll('.select-elm[required]');
    selectElms1.forEach((elm) => {
      if (elm.value === '') {
        bool = true;
      }
    });
    return bool;
  };

  /**
   * 値が重複した場合 => true と 重複した要素の配列
   * @returns {{judge: boolean, elm: NodeList[]}}
   */
  const doDuplicate = () => {
    const returnValue = { judge: false, elms: [] };

    const duplicatedElm = document.querySelectorAll(`.select-elm`);
    const duplicatedValue = {};

    duplicatedElm.forEach((element) => {
      const { value } = element.dataset;

      if (duplicatedValue[value]) {
        // 重複している要素に対する処理
        returnValue.judge = true;
        returnValue.elms.push(document.querySelectorAll(`.select-elm[data-value="${value}"]`));
      } else {
        duplicatedValue[value] = true;
      }
    });

    return returnValue;
  };

  /**
   * 歯抜けデータがあった場合 => true と 歯抜けデータを持つ要素の配列
   * @returns @returns {{judge: boolean, elm: NodeList[]}}
   */
  const isMissingValue = () => {
    let returnValue = { judge: null, elms: [] };

    const inputedElms = document.querySelectorAll('.select-elm[data-inputed="done"]');

    if (inputedElms.length === 0) {
      returnValue.judge = false;
      return returnValue;
    }

    const lastNumber = Number(inputedElms[inputedElms.length - 1].dataset.index);
    const doubtfulElms = document.querySelectorAll('.select-elm');

    for (let i = 0; i < lastNumber; i += 1) {
      const doubtfulElm = doubtfulElms[i];
      if (doubtfulElm.value === '') {
        returnValue.judge = true;
        returnValue.elms.push(doubtfulElm);
      }
    }

    return returnValue;
  };

  const judge = () => {
    const daini = document.getElementById('kouen-2nd');
    const daisan = document.getElementById('kouen-3rd');

    if (!daini || !daisan) {
      // 第二希望または第三希望が存在しない場合
      return false;
    }

    const dainiValue = daini.dataset.value;
    const dainiDone = daini.dataset.inputed;

    const daisanValue = daisan.dataset.value;
    const daisanDone = daisan.dataset.inputed;

    const dainiJudge = dainiValue === 'initValue1' && dainiDone === 'done';
    const daisanJudge = daisanValue === 'initValue2' && daisanDone === 'done';

    const bool = dainiJudge && daisanJudge;
    return bool;
  };

  // チェック&活性化・エラー表示
  const check = () => {
    // 必須項目が入力されていなかった場合
    if (doNotInputRequired()) {
      inactiveBtn();
      return;
    }
    if (judge()) {
      activeBtn();
      return;
    }

    // 値が重複していた時の場合
    const { judge: JUDGE_DUP, elms: ELMS_DUP } = doDuplicate();
    if (JUDGE_DUP) {
      ELMS_DUP.forEach((elm) => {
        elm.forEach((e) => showError(e));
      });
      inactiveBtn();
      return;
    }

    // 歯抜けデータがあった場合
    const { judge: JUDGE_MIS, elms: ELMS_MIS } = isMissingValue();
    if (JUDGE_MIS) {
      inactiveBtn();
      return;
    }

    // 必須項目が入力されていなかった場合
    if (doNotInputRequired()) {
      inactiveBtn();
      return;
    }

    activeBtn();
  };

  // チェンジイベントを付与
  selectElms.forEach((elm) =>
    elm.addEventListener('change', (self) => {
      resetErrorMessage(); // はじめにエラー文をリセット

      const selectElm = self.target;

      const { index } = selectElm.dataset;
      selectElm.dataset.value = selectElm.value; // データ属性にvalueを代入
      if (selectElm.value === '') {
        selectElm.dataset.value = `${INITIAL_VALUE_KEY + index}`;
      }
      selectElm.dataset.inputed = 'done'; // データ属性にvalueを代入

      check(); // ボタン活性化のチェック&活性化
    })
  );

  // 履歴操作・ページ表示時に排他制御を適用する関数
  function dataSetCheck() {
    // data属性を初期化
    selectElms.forEach((elm, i) => {
      elm.dataset.value = `${INITIAL_VALUE_KEY + i}`; // data-valueに一意の値を与える
      elm.dataset.index = `${i}`; // data-indexに一意の値の値を振る

      // すでにvalueが入力済みであれば上書き
      if (elm.value !== '') {
        // console.log('すでにvalueが入力済み');
        elm.dataset.value = elm.value; // データ属性にvalueを代入
        elm.dataset.inputed = 'done'; // データ属性にvalueを代入
      }
    });
    check();
  }

  // すべてのイベントで共通処理を実行
  document.addEventListener('DOMContentLoaded', dataSetCheck);
  window.addEventListener('pageshow', dataSetCheck);
  window.addEventListener('popstate', dataSetCheck);
}

/*
* チケット枚数選択フロー
*/
let ticketWheelChair = 0; // 車椅子の枚数
let ticketNumValues = []; // 選択されたチケット枚数

// エラーメッセージを更新し、ボタンの活性/非活性を制御する
function updateErrorMessage() {
  const btn = document.getElementById('submitBtn');
  const wheelMessage = document.getElementById('wheelchair-error-message');
  if (!btn || !wheelMessage) return;

  const totalTickets = ticketNumValues.reduce((sum, current) => sum + current, 0);
  const hasInvalidSelection = ticketNumValues.includes(-1) || ticketNumValues.length === 0;

  btn.disabled = hasInvalidSelection || ticketWheelChair > totalTickets;
  wheelMessage.classList.toggle('is-show', ticketWheelChair > totalTickets);
}

// 表示されているチケット選択フォームのみ取得する
function getVisibleTicketForms(ticketForms) {
  return Array.from(ticketForms).filter((form) => window.getComputedStyle(form.parentElement).display !== 'none');
}

// チケット枚数を取得し、無効な値を除外する
function getTicketNumValues(visibleTicketForms) {
  return visibleTicketForms
    .map((ticketForm) => {
      const { value } = ticketForm;
      // 初期値（-1）を除外するため、-1は無視
      if (value === '-1') {
        return null;
      }
      const parsedValue = parseInt(value.split('|').pop(), 10);
      return Number.isNaN(parsedValue) || parsedValue === 0 ? null : parsedValue;
    })
    .filter((value) => value !== null);
}

// チケット選択状態をローカルストレージに保存する
function saveTicketForms() {
  const wheelChair = document.getElementById('wheelchair');
  const ticketValues = [...document.querySelectorAll('.ticket-num')].map((form) => form.value);
  const seatCategoryValue = document.getElementById('seat-category'); // 席種の選択内容

  if (wheelChair) {
    localStorage.setItem('ticketWheelChair', wheelChair.value);
  } else {
    localStorage.removeItem('ticketWheelChair');
  }
  localStorage.setItem('ticketForms', JSON.stringify(ticketValues));
  if (seatCategoryValue) {
    localStorage.setItem('seatCategory', seatCategoryValue.value); // 席種を保存
  }
}

// 選択されたチケット枚数を更新し、エラーメッセージを適用する
function updateTicketNumValues() {
  const visibleTicketForms = getVisibleTicketForms(document.querySelectorAll('.ticket-num'));
  ticketNumValues = getTicketNumValues(visibleTicketForms); // チケット枚数を更新

  updateErrorMessage(); // エラーメッセージを更新
}

// ローカルストレージからチケット選択状態を復元する
function restoreTicketForms() {
  const wheelChair = document.getElementById('wheelchair');
  const ticketForms = document.querySelectorAll('.ticket-num');
  const seatCategory = document.getElementById('seat-category');

  // ローカルストレージから車椅子の値を復元
  const savedWheelChair = localStorage.getItem('ticketWheelChair');
  if (wheelChair && savedWheelChair !== null) {
    wheelChair.value = savedWheelChair;
    ticketWheelChair = Number(savedWheelChair);
  }

  // ローカルストレージから選択されたチケット枚数を復元
  const savedTicketForms = JSON.parse(localStorage.getItem('ticketForms'));
  if (savedTicketForms !== null) {
    ticketForms.forEach((form, index) => {
      form.value = savedTicketForms[index] || '-1';  // 保存された値を反映
    });
  }

  // ローカルストレージから席種を復元
  const savedSeatCategory = localStorage.getItem('seatCategory');
  if (seatCategory && savedSeatCategory !== null) {
    seatCategory.value = savedSeatCategory;  // 保存された席種を反映
  }

  setTimeout(() => {
    updateTicketNumValues();
  }, 100);
}

// チケット関連のイベントハンドラをセットする
function ticketFn() {
  const wheelChair = document.getElementById('wheelchair');
  const ticketForms = document.querySelectorAll('.ticket-num');
  const categorySelect = document.getElementById('seat-category');
  const submitBtn = document.getElementById('submitBtn');

  // 席種が変更されたとき、チケット選択をリセット
  if (categorySelect) {
    categorySelect.addEventListener('change', () => {
      ticketForms.forEach((form) => {
        form.value = '-1'; // 枚数選択フォームをリセット
      });
      // 車椅子フォームをリセット
      if (wheelChair) {
        wheelChair.value = '0';
        ticketWheelChair = 0;
      }
      updateTicketNumValues(); // チケット枚数を再計算
    });
  }

  // 車椅子の枚数変更時
  if (wheelChair) {
    wheelChair.addEventListener('change', () => {
      ticketWheelChair = Number(wheelChair.value); // 車椅子の枚数を更新
      updateErrorMessage(); // エラーメッセージを更新
    });
  }

  // チケット枚数変更時
  ticketForms.forEach((form) => form.addEventListener('change', updateTicketNumValues));

  // 入力変更時にローカルストレージへ保存
  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      saveTicketForms();
    });
  }

  // ページ遷移や戻るボタン時にローカルストレージから復元
  window.addEventListener('pageshow', restoreTicketForms);
  window.addEventListener('popstate', restoreTicketForms);

  restoreTicketForms();
}


// 席種と希望枚数のセレクトボックスの紐付け
function seatType() {
  const seatCategory = document.getElementById('seat-category');
  if (!seatCategory) return;

  // id="group_"がつくselect-wrapとselect-inputを非表示 & disabled
  const hideSelectBox = () => {
    // select-wrapの処理
    const selectGroups = document.querySelectorAll('.select-wrap[id^="group_"]');
    selectGroups.forEach((group) => {
      group.style.display = 'none';
      const selectElement = group.querySelector('select');
      if (selectElement) {
        selectElement.disabled = true;
      }
    });

    // select-inputの処理
    const inputGroups = document.querySelectorAll('.select-input');
    inputGroups.forEach((input) => {
      input.disabled = true;
    });
  };

  const showTargetSelectBox = () => {
    const selectedOption = seatCategory.options[seatCategory.selectedIndex];

    if (selectedOption.id) {
      const safeId = CSS.escape(selectedOption.id);

      // select-wrapの処理
      const targetSelectGroups = document.querySelectorAll(`.select-wrap.${safeId}`);
      targetSelectGroups.forEach((group) => {
        group.style.display = 'block';
        const selectElement = group.querySelector('select');
        if (selectElement) {
          selectElement.disabled = false;
        }
      });

      // select-inputの処理
      const targetInputGroups = document.querySelectorAll(`.select-input.${safeId}`);
      targetInputGroups.forEach((input) => {
        input.disabled = false;
      });
    }
  };

  const initialize = () => {
    showTargetSelectBox();
  };
  hideSelectBox();
  setTimeout(() => {
    initialize();
  }, 100);

  seatCategory.addEventListener('change', () => {
    hideSelectBox();
    showTargetSelectBox();
  });
}


/*
* 履歴
*/
function detailPaymentBtn() {
  const paymentBtn = document.getElementById('detailPaymentBtn'); // 決済へ進むボタン
  const receiveTicketElem = Array.from(document.getElementsByClassName('ticket-take-off')); // 引取方法選択ラジオボタン
  const paymentElem = Array.from(document.getElementsByName('ticketPayment')); // 決済方法選択ラジオボタン
  if (!paymentBtn) return;
  // 初期状態のボタン非活性
  paymentBtn.disabled = true;
  if (receiveTicketElem.length === 1) {
    receiveTicketElem[0].checked = true;
  }
  if (paymentElem.length === 1) {
    paymentElem[0].checked = true;
  }

  // 引き取り方法の値を決済フォームにセットする関数
  function setPickupValue() {
    // 選択されている引き取り方法を取得
    let selectedPickup = null;
    [...receiveTicketElem].forEach((radio) => {
      if (radio.checked) {
        selectedPickup = radio.value;
      }
    });

    // 選択されている決済方法のフォームを取得
    const selectedPaymentRadio = [...paymentElem].find((radio) => radio.checked);
    const selectedPaymentForm = selectedPaymentRadio ? selectedPaymentRadio.closest('form') : null;

    if (selectedPickup && selectedPaymentForm) {
      const inputField = selectedPaymentForm.querySelector('input[name="hakkenKbn"]');
      if (inputField) {
        inputField.value = selectedPickup; // 引き取り方法をセット
      }
    }
  }

  // 選択されていない決済方法のinputからvalueを削除する関数
  function clearOtherPaymentInputValue(selectedRadio) {
    paymentElem.forEach((radio) => {
      if (radio !== selectedRadio) {
        const paymentForm = radio.closest('form');
        if (paymentForm) {
          const inputField = paymentForm.querySelector('input[name="hakkenKbn"]');
          if (inputField) {
            inputField.value = ''; // 選択されていない方のinputからvalueを削除
          }
        }
      }
    });
  }

  // 決済方法ラジオボタンのどちらかしかチェックできないようにする関数
  function paymentCheckBtn() {
    paymentElem.forEach((radio) => {
      radio.addEventListener('change', () => {
        paymentElem.forEach((r) => {
          if (r !== radio) r.checked = false;
        });
        setPickupValue(); // 決済方法が選択された後に引き取り方法を反映
        clearOtherPaymentInputValue(radio); // 選択されていない決済方法のinputからvalueを削除
      });
    });
  }

  // ラジオボタンがチェックされているかどうか調べる関数
  function updateButton() {
    let receiveTicketChecked = false;
    let ticketPaymentChecked = false;
    receiveTicketElem.forEach((input) => {
      if (input.checked) {
        receiveTicketChecked = true;
      }
    });
    paymentElem.forEach((input) => {
      if (input.checked) {
        ticketPaymentChecked = true;
      }
    });
    paymentBtn.disabled = !(receiveTicketChecked && ticketPaymentChecked); // 両方チェックがあれば活性化
    const selectedPayment = Array.from(paymentElem).find((input) => input.checked);
    if (selectedPayment) {
      const form = selectedPayment.closest('form');
      if (form) {
        paymentBtn.setAttribute('form', form.id);
      }
    }
  }

  // 引取方法選択、決済方法選択にチェンジイベント付与
  receiveTicketElem.forEach((input) => {
    input.addEventListener('change', () => {
      setTimeout(() => {
        updateButton();
      }, 100);
      setPickupValue();
    });
  });
  paymentElem.forEach((input) => {
    input.addEventListener('change', () => {
      setTimeout(() => {
        updateButton();
      }, 100);
      setPickupValue();
      paymentCheckBtn();
      const form = input.closest('form');
      if (form) {
        paymentBtn.setAttribute('form', form.id); // form属性を更新
      }
    });
  });

  // 履歴操作・ページ表示時に排他制御を適用する関数
  function applyPaymentCheck() {
    setPickupValue();
    updateButton();
    paymentCheckBtn();
  }

  // すべてのイベントで共通処理を実行
  document.addEventListener('DOMContentLoaded', applyPaymentCheck);
  window.addEventListener('pageshow', applyPaymentCheck);
  window.addEventListener('popstate', applyPaymentCheck);

  updateButton();
  setPickupValue();
}

// お申込み取消し確認モーダル
function cancelModalFunc(){
  const tyusenNums = document.querySelectorAll('.tyusen-num');
  const tyusenNumsEnc = document.querySelectorAll('.tyusen-num-enc');
  const cancelBtns = document.querySelectorAll('.cancelBtn');
  for (let i = 0; i < cancelBtns.length; i+= 1) {
    const element = cancelBtns[i];
    element.addEventListener("click", (e) => {

      let param = tyusenNums[i].textContent;
      let paramEnc = tyusenNumsEnc[i].textContent;
      // console.log(`/entry/cancel/confirm?tyusenNo=${param}&tyusenNoEnc=${paramEnc}`);

      $('#modalOverlay, #modalWrap').fadeIn();
      $('body').css('overflow-y', 'hidden');
      // confirm.html読み込み
      $.ajax({
        url: `/entry/cancel/confirm?tyusenNo=${param}&tyusenNoEnc=${paramEnc}`,
        type: 'get',
        dataType: 'html',
      }).done((data) => {
        $('#modalWrap').html(data);
      })
    });
  }

  $('#modalOverlay').on('click',() =>{
    $('#modalOverlay, #modalWrap').fadeOut();
    $('body').css('overflow-y','auto');
  });
  $(document).on('click', '#closeModal', () => {
    $('#modalOverlay, #modalWrap').fadeOut();
    $('body').css('overflow-y','auto');
  })
}

// 注意事項同意チェック
function agreeCheckFunc() {
  const agreeCheck = document.getElementById('agree-check');
  const entrySubBtn = document.getElementById('entrySubBtn');
  const paySubBtn = document.getElementById('paySubBtn');

  if (agreeCheck) {
    // entrySubBtnが存在する場合
    if (entrySubBtn) {
      entrySubBtn.disabled = true;
      agreeCheck.addEventListener('change', () => {
        if (agreeCheck.checked) {
          entrySubBtn.disabled = false;
        } else {
          entrySubBtn.disabled = true;
        }
      });
    }

    // paySubBtnが存在する場合
    if (paySubBtn) {
      paySubBtn.disabled = true;
      agreeCheck.addEventListener('change', () => {
        if (agreeCheck.checked) {
          paySubBtn.disabled = false;
        } else {
          paySubBtn.disabled = true;
        }
      });
    }
  }
}

// 二重送信禁止
function dbClick(){

  // 申し込み内容確認（ticket.html ）のボタン
  const entryForm = document.forms['form-confirm'];

  const confirmBtn = document.getElementById('entrySubBtn');
  if(confirmBtn){
    confirmBtn.addEventListener('click',() => {
      confirmBtn.disabled = true;
      if(entryForm){
        entryForm.submit();
      }
    })
  }

  // 取り消し確認（cancel/confirm.html ）のボタン
  document.addEventListener('click', ({target}) => {
    if (target.id === 'cancelConfBtn') {
      const cancelForm = document.forms['form-cancel-confirm'];

      target.disabled = true;
        cancelForm.submit();
    }
  });

  let isClicked = false;
  const formOnline = document.forms.payOnline;
  const formStore = document.forms.payStore;

  const payOnlineBtn = document.getElementById('payOnlineBtn');
  const payStoreBtn = document.getElementById('payStoreBtn');

  // オンライン決済
  if(payOnlineBtn){
    payOnlineBtn.addEventListener('click',() => {
      if (!isClicked){
        formOnline.submit();
        payOnlineBtn.disabled = true;
        isClicked = true;
      }
    })
  }
  // コンビニ決済
  if(payStoreBtn){
    payStoreBtn.addEventListener('click',() => {
      if (!isClicked){
        formStore.submit();
        payStoreBtn.disabled = true;
        isClicked = true;
      }
    })
  }
}

// 右クリック禁止
function rightClickDisabled() {
  document.body.oncontextmenu = () => false;
}

// ブラウザバック・リロードで関数発火
function reload(){
  const payOnlineBtn = document.getElementById('payOnlineBtn'); // オンライン決済ボタン
  const payStoreBtn = document.getElementById('payStoreBtn'); // コンビニ決済ボタン

  // 決済ボタンを活性化する
  const activeBtn = () =>{
    if(!payOnlineBtn || !payStoreBtn) return ;
    payStoreBtn.disabled = false;
    payOnlineBtn.disabled = false;
  }

  window.addEventListener("pageshow", (event) => {
    let entries = performance.getEntriesByType("navigation");
    entries.forEach((entry) => {
      // 画面遷移の種類を判定
      // ブラウザバックで戻ってきた場合の処理
      if(entry.type === 'back_forward' || entry.type === 'navigate') {
        activeBtn();
      }
      // リロードの場合の処理
      if(entry.type === 'reload') {
        activeBtn();
      }
    });
  });
}





window.addEventListener("DOMContentLoaded", () => {
  const {body} = document;
  uaCheck();
  cancelModalFunc();
  dbClick();
  rightClickDisabled();
  reload();
  showAccordion('.accordion-title');
  if (body.classList.contains('page-entry-perform')) {
    formCheck();
    localStorage.removeItem('ticketWheelChair');
    localStorage.removeItem('ticketForms');
    localStorage.removeItem('seatCategory');
  }
  if (body.classList.contains('page-entry-ticket')) {
    seatType();
    ticketFn();
  }
  if (body.classList.contains('page-entry-confirm')) {
    const entrySubBtn = document.getElementById('entrySubBtn');
    if (entrySubBtn) {
      entrySubBtn.addEventListener('click', () => {
        localStorage.removeItem('ticketWheelChair');
        localStorage.removeItem('ticketForms');
        localStorage.removeItem('seatCategory');
      });
    }
  }
  if (body.classList.contains('page-history-list') || body.classList.contains('page-history-detail')) {
    detailPaymentBtn();
  }
  agreeCheckFunc();
});
